import { ForbiddenError                       } from 'lib/errors'
import { sessionSetting, terminalLoginSetting } from 'alto-react-client-auth/lib/settings'

class LoginFailed
  constructor: (@data) ->
    @name         = @constructor.name
    @stack        = (new Error).stack
    @message      = @messages[@data.detail]
    @data.message = @message

  @::__proto__ = Error::

  messages:
    'not a registered terminal': 'Tento terminál není korektně zaregistrován'
    'bad credentials': 'Špatné číslo karty'
    'user not activated': ('Účet není aktivován. Ve své emailové schránce najdete aktivační ' +
                           'email s odkazem, pomocí kterého dokončíte aktivaci účtu.')

export default class TerminalLoginService
  constructor: (@auth, @settings, @history) ->
    @session = sessionSetting(@settings)

  perform: (cardNumber) ->
    @auth.terminalLogin(cardNumber)
      .then (response) =>
        @history.push('/')
        null # otherwise runaway promise

      .catch ForbiddenError, (error) =>
        throw new LoginFailed(error.data)

TerminalLoginService.Failed = LoginFailed
